import { useState, useEffect } from 'react';
import "./FormShare.css";
import { useDispatch, useSelector } from 'react-redux';
import { selectUIStates, selectUser, setUIStates } from '../../redux/features/appData';
import { FormHeader } from '../form-header/FormHeader';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { FormExtended } from 'effno-core';
import { toastFail, toastSuccess } from '../../config';
import { apiGetForm } from '../../services/FormService';
import { handleCopyText } from '../shared/uiHelpers';
import config from "environment";

const clientUrl = config.clientUrl;

const EMBED_TYPES = {
    STANDARD: "standard",
    POPUP: "popup",
    FULL_PAGE: "full-page"
}

type FormShareProps = {
}

export const FormShare = ({} : FormShareProps) => {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates);

    const [form, setForm] = useState<FormExtended | null>(null);
    const [formId, setFormId] = useState<string | undefined>(undefined);

    useEffect(() => {
        // if not logged in bounce there
        if (!storeUser) {
            navigate("/login");
            return;
        }
    }, []);
    
    useEffect(() => {
        setFormId(params.formId);
    }, [params]);

    useEffect(() => {
        if (!form && formId) {
            (async () => {
                const theForm = await apiGetForm(formId);

                if (!theForm) {
                    toast("Error getting form", toastFail);
                    return;
                }

                setForm(theForm);
                
            })()
        }
    }, [formId])

    const getShareURL = () => {
        return clientUrl + "/form/" + form?.publicLink;
    }

    const handleCopyLink = async () => {
        if (!form) {
            return;
        }

        await handleCopyText(getShareURL());
        // toast("Copied", toastSuccess);
    }

    const handleOpenEmbed = (type: string) => {
        console.log("[FormShare/handleOpenEmbed] open embed: ", type);
    }

    if (storeUser) {
        document.body.className = storeUser.theme;
    }

    const questionOrder = form?.questionOrder ? JSON.parse(form.questionOrder) : null;

    console.log("[FormShare] form: ", form);
    
    return (
        <>
            <div id="form-share">
                <div className="form-share-header">
                    <FormHeader />
                </div>

                <div className="form-share-body">
                    <div className="form-share-copy-link"> 
                        <div className="form-share-title">
                            Share Link
                        </div>
                        <div 
                            className="form-share-content"
                            
                        >
                            Your form is now published and ready to be shared with the world! 
                            Copy this link to share your form on social media, messaging apps or via email.
                        </div>
                        <div 
                            className="form-share-link"
                            onClick={handleCopyLink}
                        >
                            <input
                                type="text"
                                value={getShareURL()}
                                disabled={true}
                                style={{pointerEvents: "none"}}
                            />
                        </div>
                        <div className="form-share-button">
                            <button
                                className="button-save"
                                onClick={handleCopyLink}
                            >
                                Copy
                            </button>
                        </div>
                       
                    </div>

                    <div className="form-share-embed">
                        {/* <div className="form-share-title">
                            Embed Form
                        </div> */}
                        {/* <div className="form-share-content">
                            Use these options to embed your form into your own website.
                        </div>
                        <div className="form-share-embed-types">
                            <div className="form-share-embed-type">
                                <div 
                                    className="form-share-embed-type-image"
                                    onClick={()=>handleOpenEmbed(EMBED_TYPES.STANDARD)}
                                >
                                    <img src="/media/embed-standard.jpg" />
                                </div>
                                <div className="form-share-embed-type-name">
                                    Standard
                                </div>
                            </div>
                            <div className="form-share-embed-type">
                                <div 
                                    className="form-share-embed-type-image"
                                    onClick={()=>handleOpenEmbed(EMBED_TYPES.POPUP)}
                                >
                                    <img src="/media/embed-popup.jpg" alt="iframe" />
                                </div>
                                <div className="form-share-embed-type-name">
                                    Popup
                                </div>
                            </div>
                            <div className="form-share-embed-type">
                                <div 
                                    className="form-share-embed-type-image"
                                    onClick={()=>handleOpenEmbed(EMBED_TYPES.FULL_PAGE)}
                                >
                                    <img src="/media/embed-full-page.jpg" alt="iframe" />
                                </div>
                                <div className="form-share-embed-type-name">
                                    Full Page
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="form-share-message">
                            Embeds are coming soon!
                        </div> */}
                    </div>
                    
                </div>
            </div>

            <Toaster />

        </>
        
    )
}